import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import Accordion from './Accordion';
import Tab from './Tab';
import SpNavi from './SpNavi';
// import ToTop from './ToTop';
// import DropDownMenu from './DropDownMenu';
// import BlockLink from './BlockLink';
// import Gmap from './Gmap';
import bowser from 'bowser';
// import matchheight from 'jquery-match-height';
import swiper from 'swiper';
import inview from 'jquery-inview';
import FloatAnimation from './FloatAnimation';
import {TweenMax , TimelineLite} from "gsap";

console.log(bowser);
if(bowser.msie === true) {
	let version = 'ie_'+Math.floor(bowser.version);
	$('body').addClass('ie '+version);
}else if(bowser.msedge === true){
	$('body').addClass('edge');
}else if(bowser.firefox === true){
	$('body').addClass('ff');
}else if(bowser.chrome === true){
	$('body').addClass('chrome');

}else if(bowser.tablet === true){
	$('body').addClass('tablet');
}
if(bowser.mobile === true){
	$('body').addClass('device--mobile');
	if(bowser.android === true) {
		$('body').addClass('device--mobile--android');
	}
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "win7";
}else{
	os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
//通常盤
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200,
	fixer:100
};
const spnavi = new SpNavi(param);
// spnavi.exec();

//execに可変引数で処理を渡してナビの開閉時に処理させるサンプル
//例として、SPナビでアコーディオンを開くたびにiScrollをリセットする
let spnav_accordion_1 = (scroller)=>{
	$('#scroller .global_nav > ul > li > p').off();
	$('#scroller .global_nav > ul > li > p').on('click',function(){
		let $parent = $(this).parent('li');
		let $child = $(this).next('.global_nav-child');
		let status = $child.css('display');

		if(status == 'block'){
			$child.slideUp(300,function(){
				scroller.refresh();
			});
			$parent.removeClass('is-active');
		}else{
			$child.slideDown(300,function(){
				scroller.refresh();
			});
			$parent.addClass('is-active');
		}
		// setTimeout(function(){
		// 	scroller.refresh();
		// },550);
		// return false;
	});
}
spnavi.exec(spnav_accordion_1);
/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
// const totop = new ToTop('#totop','#global_footer',100,400);
// totop.exec();

/**
 * 外部リンク・PDF・Word・Exlsに_blankの自動付与
 *
 */
// const link_icon = require('./link_icon');
// link_icon();
/* ===============================================
DropDown

markp:
<ul>
	<li>
		<a href=""></a>
		<ul class="child">
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
		</ul>
	</li>
	<li>
		<a href=""></a>
	</li>
	<li>
		<a href=""></a>
	</li>
</ul>
=============================================== */
// const dd = new DropDownMenu('ul li','.child',200);
// dd.exec();
/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
const ac = new Accordion($('.faq-q'));
ac.exec();
/* ===============================================
Tab

markup:
<div class="tc">
	<ul>
		<li>tab1</li>
		<li>tab2</li>
		<li>tab3</li>
	</ul>
	<div class="tc_content">
		tabcon1tabcon1tabcon1tabcon1tabcon1tabcon1
	</div>
	<div class="tc_content">
		tabcon2tabcon2tabcon2tabcon2tabcon2tabcon2
	</div>
	<div class="tc_content">
		tabcon3tabcon3tabcon3tabcon3tabcon3tabcon3
	</div>
</div>
=============================================== */
// const tab = new Tab('.tc li','.tc .tc_content');
// tab.exec();

// /* gmap
// ----------------------- */
// let gmap = new Gmap();

// $(window).on('load',function(){
// 	if($("#map").length>0){
// 		gmap.exec();
// 	}
// });

/* ===============================================
instagram with infinityScroll

markup:
<div class="slide--instagram_wrapper" id="insragram">
	<div class="slide--instagram">
		<div id="js-slide--instagram">
			<ul class="inner"></ul>
		</div>
	</div>
</div>
=============================================== */
/**
 *
 * @param {sring} requet_url instagramのリクエストURL ./_instagram_template.htmlにhtmlテンプレートサンプルあり
 * @param {element} append_target 読み込んだ写真を追加する要素
 * @param {element} slide_target スライドショーさせる要素
 */
// const instagram = require('./instagram');
// instagram('request_url','#js-slide--instagram .inner','#js-slide--instagram');



/* ===============================================
#	define
=============================================== */
const w = $(window);

/* ===============================================
#	global header fixed
=============================================== */
const gHeader = $("#global_header");
const gHeader_h = gHeader.height();
w.on("scroll",function(){
	let scrlY = $(window).scrollTop();
	// console.log(scrlY);
	if(scrlY> gHeader_h){
		$(gHeader).addClass("is-fixed");
	}else{
		$(gHeader).removeClass("is-fixed mod-fade");
	}
	if(scrlY> 400){
		$(gHeader).addClass("is-show mod-fade");
	}else{
		$(gHeader).removeClass("is-show");
	}
});

/* ===============================================
#	home mv swiper
=============================================== */
let home_mv = new Swiper ('.home_mv', {
	loop: true,
	speed:1000,
	autoplay:4000,
	effect:"fade",
	nextButton: '.swiper-button-next',
	prevButton: '.swiper-button-prev',
	pagination:'.swiper-pagination',
	paginationClickable:true,
});

/* ===============================================
#	home instagram swiper
=============================================== */
function swiper_instagram_init(){
	let width = w.width();
	let slide_ig = new Swiper ('.slide_ig', {
		speed:1000,
		nextButton: '.swiper-button-next',
		prevButton: '.swiper-button-prev',
		pagination:'.swiper-pagination',
		loop: true,
		slidesPerView: 'auto',
	});
}
const get_instagram = ()=>{
	if($(".slide_ig").length){
		let html="";
		$.ajax({
			url:"../wp-content/themes/kogirekai/request_isntagram.php",
			type:"POST",
			dataType:"json",
		})
		//通信成功時
		.done((data)=>{
			// console.log(data);
			$.each(data.data,function(index,value){
				let link = value.link,
					src = value.images.standard_resolution.url;
				html += `<div class="swiper-slide slide_ig_item"><a href="${link}" target="_blank" style="background-image:url(${src});"></a></div>`;
			})
			// console.log("done");
		})
		//通信失敗時
		.fail(()=>{
			// console.log("fail");
		})
		.always(()=>{
			$(".slide_ig .swiper-wrapper,.ig_sp").append(html);
			TweenMax.to(".home_instagram-inner-slide",0.8,{opacity:1,ease: Power2.easeIn});
			swiper_instagram_init();
		})
	}
}
get_instagram();

/* ===============================================
#	items detail swiper
=============================================== */
if($(".items-image .swiper-slide").length >1){
	let items_image = new Swiper ('.items-image', {
	    nextButton: '.swiper-button-next',
	    prevButton: '.swiper-button-prev',
		loop:true
	});

// サムネイルのactiveの付け替え
	items_image.on("onSlideChangeEnd",function(){
		let num = $(".items-thumb-slide").length;
		let result = (items_image.activeIndex) % num -1;
		$(".items-thumb-slide").removeClass("is-active");
		$(".items-thumb-slide").eq(result).addClass("is-active");
	});
	//スライダー送り
	$(".items-thumb-slide").on("click",function(){
		let index = $(this).index();
		items_image.slideTo(index +1);
		$(".items-thumb-slide").removeClass("is-active");
		$(this).addClass("is-active");
	});
}
/* ===============================================
#	title font anim
=============================================== */
function fontAnim(){
	$(".js-title-font-anim").each(function(){

		let target = $(this);

		let splitText = target.text().split("");
		target.html("");
		target.addClass("start-anim")

		//一文字ずつspanでwrap
		$.each(splitText,function(id,elem){
			let newEl = $("<span/>").text(elem).css({opacity:0});
			newEl.appendTo(target);
		});

		//small設定
		let small = target.data("small");
		if(small){
			let smallArr = small.split(",");
			let smallTarget = "span:gt("+ smallArr[0]+"):lt("+ smallArr[1]+")";
			// console.log("smallTarget:"+ smallTarget);
			$(this).children(smallTarget).wrapAll("<small></small>");
		}

		//前後の[]の処理
		target.prepend('<span class="js-title-font-anim-header"></span>');
		target.append('<span class="js-title-font-anim-footer"></span>');

		//改行設定
		let br = target.data("br");
		if(br){
			let firstHalfTarget = "span:lt("+ br +")";
			// console.log("smallTarget:"+ smallTarget);
			$(this).children(firstHalfTarget).wrapAll("<p class='first-half'></p>");
			$(this).children("span").wrapAll("<p class='last-half'></p>");
		}	

		//アニメーション
		// let tl = new TimelineMax();
		let tl = new TimelineMax({paused:true});
		let target_span = target.find("span");
		tl.staggerTo(target_span,0.5,{opacity:1},0.1);
		// tl.set("span",{opacity:1});	//開発用

		$(this).bind("inview",function(){
			tl.play();	
		});
		
	});
} 
fontAnim();

/* ===============================================
#	float animation
=============================================== */
import InviewAnim from "./InviewAnim";
const anim = new InviewAnim(".js-inview-anim");
anim.exec();
anim.homeAnim();

/* ===============================================
#	faq
=============================================== */
let $flow_box = $(".flow_box-inner");
let appendElem = '<span class="js-line1"/><span class="js-line2"/>';
$flow_box.prepend(appendElem);

/* ===============================================
#	tel link
=============================================== */
$(function(){
    var ua = navigator.userAgent;
    if(ua.indexOf('iPhone') > 0 && ua.indexOf('iPod') == -1 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0 ){
        $('.tel-link').each(function(){
            var str = $(this).text();
            $(this).html($('<a>').attr('href', 'tel:' + str.replace(/-/g, '')).append(str + '</a>'));
        });
    }
});
/* ===============================================
#	blog aside
=============================================== */
$(".aside-title").on("click",function(){
	$(this).next("ul").slideToggle();
	$(this).toggleClass("is-active");
});

$(".aside-archive_list-year p").on("click",function(){
	$(this).next(".aside-archive_list-month").slideToggle();
});

$(".js-list-toggle > .cat-item >a").on("click",function(e){
	e.preventDefault();
	$(this).next(".children").slideToggle();
});
/* ===============================================
#	contact form
=============================================== */
$('input[name="your-zip[data][1]"]').keyup(function() {
	AjaxZip3.zip2addr('your-zip[data][0]','your-zip[data][1]','your-address-1','your-address-2');
});

if($("span.error")[0]){
	let scroll = $(".section-cont.mod-contact-form").offset().top - 80;
	$("body,html").delay(200).animate({scrollTop:scroll},600,"swing");
}